module.exports = __webpack_public_path__ + "static/media/logo_group_negro_01.6ac8de30.png";